import type { Platform } from 'componentregistry/platform/Platform';
import {
  PLATFORM_VERSION,
  BUILD_VERSION,
  BUILD_DATE,
} from 'layout/Header/About';
import Logger from 'utils/Logger';

export interface PlatformUpdateNotifierConfigType {
  onSuccess?: (registration: ServiceWorkerRegistration) => void;
  onUpdate?: (registration: ServiceWorkerRegistration) => void;
}

const SWRs: {
  success?: ServiceWorkerRegistration;
  update?: ServiceWorkerRegistration;
} = {};

export const config: PlatformUpdateNotifierConfigType = {
  onSuccess: (registration: ServiceWorkerRegistration) => {
    SWRs.success = registration;
  },
  onUpdate: (registration: ServiceWorkerRegistration) => {
    SWRs.success = registration;
  },
};

export function registerPlatformWithServiceWorker(platform: Platform) {
  // @ts-ignore Cypress
  if (window.Cypress) {
    // @ts-ignore cloudio_platform
    window.cloudio_platform = platform;
  }
  config.onSuccess = () => {
    Logger.trace(
      `Application cached... ${PLATFORM_VERSION} - ${BUILD_VERSION} - ${BUILD_DATE}.`,
    );
  };
  config.onUpdate = () => {
    Logger.trace(
      `Application updated... ${PLATFORM_VERSION} - ${BUILD_VERSION} - ${BUILD_DATE}`,
    );
  };
  if (SWRs.success) {
    config.onSuccess(SWRs.success);
    delete SWRs.success;
  }
  if (SWRs.update) {
    config.onUpdate(SWRs.update);
    delete SWRs.update;
  }
}
